import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as FileSaver from "file-saver";
import {
  ViewService,
  Manifest,
  ManifestService,
  ConfigService,
  ManifestPages,
  getFormattedDate,
} from "../../common";

import { Subscription } from "rxjs";
import headerCss from "./template";

@Component({
  styleUrls: ["./manifest-detail-view.css"],
  selector: "manifest-detail-view",
  templateUrl: "./manifest-detail-view.html",
  standalone: false,
})
export class ManifestDetailView implements OnInit, OnDestroy {
  @Input() manifest: Manifest;
  paramSubscription: Subscription;
  actions = { printLabel: true };
  pagedLines: { key: number; value: { lines: ManifestPages[]; hs: string } }[];
  allowmoveTop: boolean;
  manifestPrintMargins: number[];
  RestOfManifest: boolean;
  updateIndex: boolean;
  lastIndex: number;
  nextIndex: number;

  constructor(
    private viewService: ViewService,
    private route: ActivatedRoute,
    private configService: ConfigService,
    private manifestService: ManifestService
  ) {
    viewService.setViewData({ pageTitle: "Manifest #" });
  }

  counter(n: number): Array<number> {
    return Array.from(new Array(n), (x, i) => i + 1);
  }
  ngOnInit() {
    this.configService.get().subscribe((appConfig) => {
      this.manifestPrintMargins = appConfig.manifestPrintMargins;
    });
    this.paramSubscription = this.route.params.subscribe((params) => {
      this.loadManifest(params["manifestId"]);
      this.lastIndex = 4;
      this.nextIndex = this.lastIndex + 10;
    });
  }

  loadNextSet() {
    console.log("nextIndex", this.nextIndex);
  }

  downloadReport(trackingNo: string) {
    this.manifestService.report(trackingNo).subscribe(
      (resp) => {
        FileSaver.saveAs(resp, `WIMS-Manifest-${getFormattedDate()}-${trackingNo}.xlsx`);
      },
      async (error) => {
        console.log(JSON.parse(await error.error.text()).message);
      }
    );
  }

  downloadPrint(trackingNo: string) {
    this.manifestService.print(trackingNo).subscribe(
      (resp) => {
        FileSaver.saveAs(resp, `WIMS-Manifest-${getFormattedDate()}-${trackingNo}.pdf`);
      },
      async (error) => {
        console.log(JSON.parse(await error.error.text()).message);
      }
    );
  }

  loadManifest(manifestShipNo: string) {
    this.manifestService.get(manifestShipNo).subscribe((manifest) => {
      this.manifest = manifest;
      let editLink = manifest.canEdit
        ? { text: "» Edit", routeData: this.viewService.routerLink(["edit"]) }
        : undefined;
      this.viewService.setViewData({
        pageTitle: manifest.trackingNumber,
        link: editLink,
      });
      this.manifestService.getItems(manifestShipNo).subscribe((items) => {
        console.log(items);
        this.pagedLines = items;
        this.manifest.totalPages = this.pagedLines.length;
        console.log(this.pagedLines.length);
      });
    });
  }

  resetIndex() {
    this.lastIndex = 4;
    this.nextIndex = this.lastIndex + 10;
  }

  ngOnDestroy() {
    this.paramSubscription.unsubscribe();
  }

  onPrint() {
    console.log("manifestPrintMargins: ", this.manifestPrintMargins);
    this.RestOfManifest = true;
    setTimeout(() => {
      let title = document.title;
      let baseLine = 2.07;
      const textPos = "position: absolute; text-align: left;";
      const lineOffset = 0.42;
      let containersCss: string = "";
      for (let index = 0; index < 4; index++) {
        containersCss = `${containersCss}
      #ctnhm${index} {${textPos} top: ${baseLine + 0.1}in; left: 0.09in;}
      #ctndot${index} {${textPos} top: ${baseLine}in; left: 0.35in; width: 3.95in; height: 0.5in;}
      #ctnNo${index} {${textPos} top: ${baseLine + 0.1}in; left: 4.6in;}
      #ctnType${index} {${textPos} top: ${baseLine + 0.1}in; left: 5.0in;}
      #ctnqty${index} {${textPos} top: ${baseLine + 0.1}in; left: 5.525in;}
      #ctnvol${index} {${textPos} top: ${baseLine + 0.1}in; left: 6.15in;}
      #ctnwc1${index} {${textPos} top: ${baseLine}in; left: 6.545in;}
      #ctnwc2${index} {${textPos} top: ${baseLine}in; left: 6.985in;}
      #ctnwc3${index} {${textPos} top: ${baseLine}in; left: 7.425in;}
      #ctnwc4${index} {${textPos} top: ${baseLine + 0.22}in; left: 6.535in;}
      #ctnwc5${index} {${textPos} top: ${baseLine + 0.22}in; left: 6.985in;}
      #ctnwc6${index} {${textPos} top: ${baseLine + 0.22}in; left: 7.425in;}
      `;
        baseLine += lineOffset;
      }
      console.log("containersCss: ", containersCss);
      let baseLine2 = 1.9;
      const lineOffset2 = 0.5085;
      let containersCss2: string = "";
      for (let index = 0; index < 10; index++) {
        containersCss2 = `${containersCss2}
      #ctnhm2${index} {${textPos} top: ${baseLine2 + 0.1}in; left: 0.09in;}
      #ctndot2${index} {width: 3.95in; height: 0.5in; ${textPos} top: ${baseLine2}in; left: 0.35in;}
      #ctnNo2${index} {${textPos} top: ${baseLine2 + 0.1}in; left: 4.45in;}
      #ctnType2${index} {${textPos} top: ${baseLine2 + 0.1}in; left: 5in;}
      #ctnqty2${index} {${textPos} top: ${baseLine2 + 0.1}in; left: 5.525in;}
      #ctnvol2${index} {${textPos} top: ${baseLine2 + 0.1}in; left: 6.15in;}
      #ctnwc1-2${index} {${textPos} top: ${baseLine2}in; left: 6.545in;}
      #ctnwc2-2${index} {${textPos} top: ${baseLine2}in; left: 6.985in;}
      #ctnwc3-2${index} {${textPos} top: ${baseLine2}in; left: 7.425in;}
      #ctnwc4-2${index} {${textPos} top: ${baseLine2 + 0.22}in; left: 6.535in;}
      #ctnwc5-2${index} {${textPos} top: ${baseLine2 + 0.22}in; left: 6.985in;}
      #ctnwc6-2${index} {${textPos} top: ${baseLine2 + 0.22}in; left: 7.425in;}
      `;
        baseLine2 += lineOffset2;
      }

      let divElements = document.getElementById("printme").innerHTML;
      let printWindwow = window.open("", "_blank", "");
      printWindwow.document.open();

      printWindwow.document.write(
        `<html><head><title>${title} Print</title> 
      <link
      href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css"
      rel="stylesheet"
      integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x"
      crossorigin="anonymous"
    />
      <style> 
      @page {      
        margin-top: ${this.manifestPrintMargins[0]}in;
        margin-right: ${this.manifestPrintMargins[1]}in;
        margin-bottom: ${this.manifestPrintMargins[2]}in;
        margin-left: ${this.manifestPrintMargins[3]}in;
      }
      
      ${headerCss}
      ${containersCss}
      ${containersCss2}
      </style>
     </head><body>`
      );

      printWindwow.document.write(divElements);
      printWindwow.document.write("</body> </html>");
      printWindwow.document.close();
      printWindwow.focus();
      setTimeout(() => {
        printWindwow.print();
        printWindwow.close();
        this.RestOfManifest = false;
      }, 250);
    }, 100);
  }

  printComponent(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  }
}
